<template>
    <div></div>
</template>

<script>
    export default {
        name: "Category",
        props:{},

    }
</script>

<style scoped>

</style>